var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eC8RBqkH5Xb1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 18,
    height: 18,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,3h.9v-.8c0-.2.1-.3.3-.3h7.1c.2,0,.3.1.3.3v.8h.9c.1,0,.2.2.2.4v9.4h1c.2,0,.3.1.3.3v1h1.1c.2,0,.3.1.3.3v1.3c0,.2-.1.3-.3.3h-14.8c-.2,0-.3-.1-.3-.3v-1.3c0-.2.1-.3.3-.3h1.1v-1c0-.2.1-.3.3-.3h1v-9.4c0-.2.1-.4.3-.4ZM1.9,14.8v.7h14.2v-.7c-4.7,0-9.5,0-14.2,0v0ZM5.8,3h6.5v-.5h-6.5v.5v0Zm3.9,8c.1,0,.2.1.2.2s-.1.2-.2.2-.2-.1-.2-.2s0-.2.2-.2ZM8.3,11c.1,0,.2.1.2.2s-.1.2-.2.2-.2-.1-.2-.2.1-.2.2-.2Zm-3-2.7c-.4,0-.4-.6,0-.6h7.5c.4,0,.4.6,0,.6h-7.5v0Zm0-.8c-.4,0-.4-.6,0-.6h7.5c.4,0,.4.6,0,.6h-7.5v0ZM5.2,4.1h1.9c.2,0,.3.1.3.3v1.9c0,.2-.1.3-.3.3h-1.9c-.2,0-.3-.1-.3-.3v-1.9c0-.1.2-.3.3-.3Zm1.6.7h-1.3v1.2h1.2v-1.2h.1Zm4.1-.7h1.9c.2,0,.3.1.3.3v1.9c0,.2-.1.3-.3.3h-1.9c-.2,0-.3-.1-.3-.3v-1.9c0-.1.2-.3.3-.3Zm1.6.7h-1.2v1.2h1.2v-1.2v0ZM8.1,4.1h1.9c.2,0,.3.1.3.3v1.9c0,.2-.1.3-.3.3h-1.9c-.2,0-.3-.1-.3-.3v-1.9c0-.1.1-.3.3-.3Zm1.5.7h-1.2v1.2h1.2v-1.2v0ZM9.3,9.4v3.4h1.3v-3.4h-1.3Zm-.6,3.4v-3.4h-1.3v3.4h1.3Zm-5.4.6v.7h11.4v-.7c-3.8,0-7.6,0-11.4,0v0ZM7.1,8.8h3.8c.2,0,.3.1.3.3v3.7h2.2v-9.1c-2.9,0-5.9,0-8.8,0v9.1h2.2v-3.7c0-.2.1-.3.3-.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/Department.18a4bdbe70b3dd8ed94cf6d58aafdbd0.svg";
export { ForwardRef as ReactComponent };